import { styled } from '@ghq-abi/design-system';
import { COLORS, SIZES } from '~/shared/constants/colors';

export const DropdownContainer = styled('div', {
  position: 'absolute',
  top: '100%',
  left: 0,
  width: '100%',
  backgroundColor: '$white',
  border: `1px solid ${COLORS.DROPDOWN_BORDER}`,
  borderTop: 'none',
  borderRadius: `0 0 ${SIZES.BORDER_RADIUS} ${SIZES.BORDER_RADIUS}`,
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
  zIndex: 999999,
  maxHeight: '200px',
  overflowY: 'auto',
});

export const LoadingOption = styled('div', {
  padding: '12px 16px',
  color: '$gray600',
  fontSize: '14px',
  textAlign: 'center',
});

export const NoResultsOption = styled('div', {
  padding: '12px 16px',
  color: '$gray600',
  fontSize: '14px',
  textAlign: 'center',
});

export const FormComponentContainer = styled('div', {
  width: '100%',
  borderRadius: '4px',
  position: 'relative',
  zIndex: 1,
  border: '1px solid $gray200',
  '@md': { borderRadius: '4px' },
});

export const FormComponentHeader = styled('div', {
  width: '100%',
  padding: '$3 $3',
  backgroundColor: '#F5F6F7',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '74px',
  borderTopLeftRadius: '4px',
  '@md': { padding: '$3 $4' },
});

export const FormComponentTitle = styled('h3', {
  fontSize: '$md',
  fontWeight: '600',
  color: '$gray800',
  margin: '0',
});

export const SelectOption = styled('div', {
  padding: '$3 $4',
  fontSize: '$sm',
  color: '$gray800',
  cursor: 'pointer',
  transition: 'background-color 0.2s',

  '&:hover': {
    backgroundColor: '$gray100',
  },

  variants: {
    selected: {
      true: {
        backgroundColor: COLORS.SELECTED,
        color: COLORS.SELECTED_TEXT,

        '&:hover': {
          backgroundColor: COLORS.SELECTED,
        },
      },
    },
  },
});
